import { Component, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { NewBankComponent } from "../new-bank/new-bank.component";
import { ApsService } from "../../../services";
import { BankInfo, AddAPSRequestOfBankInfo } from "../../../models";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ErrorDialogComponent } from "../../../components/error-dialog/error-dialog.component";
import { ProcessingDialogComponent } from "../../../components/processing-dialog/processing-dialog.component";
import { NgForm } from "@angular/forms";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";


@Component({
    selector: "app-new-bank-dialog",
    templateUrl: "./new-bank-dialog.component.html",
    styleUrls: ["./new-bank-dialog.component.scss"],
})
export class NewBankDialogComponent
{

    bankInfo: BankInfo;
    addAPSRequestOfBankInfo: AddAPSRequestOfBankInfo;

    @ViewChild(NewBankComponent) newBankElement: NewBankComponent;

    constructor(
        public dialogRef: MatDialogRef<NewBankDialogComponent>,
        private apsService: ApsService,
        public snackBar: MatSnackBar,
        private dialog: MatDialog,
    ) { }

    public checkFormValidity(form: NgForm): void
    {
        if (!form.valid)
        {
            const dialogRefAlert = this.dialog.open(AlertDialogComponent, {
                panelClass: "form-field-less-than-180",
                maxWidth: "600px",
                maxHeight: "500px",
                data: {
                    title: "Alert",
                    message: "Please fully fill out the form in order to add a new bank.",
                    buttonText: "Close"
                }
            });
            dialogRefAlert.afterClosed().subscribe(() =>
            {
            });
        }
        else
        {
            this.handleSubmit();
        }
    }


    handleSubmit(): void
    {
        const dialogText: string = "Bank";

        const dialogRefProcessing = this.dialog.open(ProcessingDialogComponent, {
            data: dialogText,
            width: "400px",
            maxWidth: "90%",
            restoreFocus: false,
            disableClose: true,
        });

        this.bankInfo = this.newBankElement.getBankInfo();

        this.apsService.addBankAccount(this.bankInfo).subscribe(b =>
        {
            if (b.valueOf())
            {
                this.dialog.closeAll();
            }
            else
            {
                this.errorDialog("")
                dialogRefProcessing.close();
            }
        }, (error) =>
        {
            dialogRefProcessing.close();
            this.errorDialog(error);
        });
    }

    errorDialog(error): void
    {
        const errorMessage: string = "An error occurred while adding a bank account. \n   " + error;

        this.dialog.open(ErrorDialogComponent, {
            minWidth: "360px",
            data: errorMessage,
        });
    }
}
